/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { Flex } from '@radix-ui/themes';

import Text from 'solis/react/primitive/text';


// Header for displayed data, as opposed to Field which labels an input and stays quiet
// so the control remains the attraction.
export default ({ label, children }) =>
(
  <Flex direction = 'column' gap = '1'>
    {label && <Text.Label>{label}</Text.Label>}
    {children}
  </Flex>
);
